// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__120uy","questions":"styles_questions__AGHLo","footer":"styles_footer__2KVIv"};